import { render, staticRenderFns } from "./BoxOuterLength.vue?vue&type=template&id=b73855d6&"
import script from "./BoxOuterLength.vue?vue&type=script&lang=ts&"
export * from "./BoxOuterLength.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports